import React from 'react';
import {Routes, Route, Link} from 'react-router-dom';

const GOTop = () => {
    return(
      <Link to="#" className="back-to-top d-flex align-items-center justify-content-center">
        <i className="bi bi-arrow-up-short"></i>
      </Link>
    );
}

export default GOTop;